import Latex from "@wiris/mathtype-html-integration-devkit/src/latex";
import ServiceProvider from "@wiris/mathtype-html-integration-devkit/src/serviceprovider";
import {
  Command,
  Element as ModelElement,
  ViewElement,
  Writer,
  Notification,
} from "ckeditor5";

import { replaceModelItem } from "../../../util/document";

ServiceProvider.init({
  URI: "https://www.wiris.net/demo/plugins/app",
  server: "java",
});

export default class ConvertLatexCommand extends Command {
  execute(element: ViewElement, to: "plain" | "equation") {
    const modelElement = this.editor.editing.mapper.toModelElement(element);
    if (modelElement == null) return;

    this.editor.model.change((writer) => {
      const replacement = this.createReplacement(modelElement, to, writer);
      if (replacement == null) return;
      replaceModelItem(modelElement, replacement, writer);
    });
  }

  private createReplacement(
    element: ModelElement,
    to: "plain" | "equation",
    writer: Writer,
  ) {
    switch (to) {
      case "plain":
        return writer.createText(`$${element.getAttribute("latex")}$`);
      case "equation": {
        const latex = element.getAttribute("latex") as string;
        const mathml = this.processMathML(
          Latex.getMathMLFromLatex(latex, false),
        );
        if (mathml == null) {
          this.editor.plugins
            .get(Notification)
            .showWarning(
              "LaTeX expression cannot be converted to an equation.",
            );
          return;
        }
        return writer.createElement("mathml", {
          formula: mathml,
        });
      }
    }
  }

  private processMathML(mathml: string) {
    const parsed = new DOMParser().parseFromString(
      mathml,
      "application/xhtml+xml",
    );

    const root = parsed.getRootNode();
    if (!(root instanceof Document)) return;

    const mathElement = root.querySelector("math");
    if (mathElement == null) {
      //
      // This means that the LaTeX equation couldn't be converted into mathml
      //
      return;
    }

    /*
    The mathml from the getMathMLFromLatex method includes an
    <annotation> element which contains the original LaTeX encoding
    This seems to the wiris plugin, so we have to remove it
  
    Example:
    <math>
      <semantics>
        <msqrt><mn>5</mn></msqrt>
        <!--annotation encoding="LaTeX">\sqrt{5}</annotation--> 
      </semantics>
    </math>
    */
    for (const annotation of mathElement.querySelectorAll("annotation")) {
      annotation.remove();
    }

    return mathElement.outerHTML;
  }
}
